import { Button, Col, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./css/Delete.css";
import { IEnterReasonProps } from "./DeleteDocumentInterface";
import SuccessPopUp from "../generic_components/SuccessPopUp";
import { DeleteDocumentAsync } from "../../api/simDocuments/DeleteDocumentService";
import ErrorMessage from "../generic_components/ErrorMessage";
import { MaxReasonLength } from "../../common/Contants";

export default function EnterReason({
  document,
  isAdvancedUser,
}: IEnterReasonProps) {
  const [reason, setReason] = useState<string>("");
  const [disabledDelete, setDisabledDelete] = useState(true);
  const canUserDelete = isAdvancedUser || !document.advancedUserUpload;
  const isReasonValid = (reason: string) => reason !== "";
  const [load, setLoad] = useState(false);
  const [successPopUp, setSuccessPopUp] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  useEffect(() => {
    setErrorMessages([]);
    if (canUserDelete && isReasonValid(reason)) {
      setDisabledDelete(false);
    } else {
      setDisabledDelete(true);
    }
  }, [reason, document, isAdvancedUser]);

  useEffect(() => {
    const deleteDocument = async () => {
      try {
        await DeleteDocumentAsync({
          documentReference: document.documentReference,
          reason,
        });
        setSuccessPopUp(true);
      } catch (error: any) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          const messages = errors.map((err: any) => err.message);
          setErrorMessages(messages);
        } else {
          setErrorMessages([error.message]);
        }
      } finally {
        setLoad(false);
      }
    };

    if (load) {
      deleteDocument();
    }
  }, [load]);

  const handleSend = async () => {
    setLoad(true);
  };

  return (
    <>
      {errorMessages.length > 0 && <ErrorMessage errors={errorMessages} />}
      <Col xs={5}>
        <textarea
          value={reason}
          onChange={(e) => {
            const newReason = e.target.value;
            if (newReason.length <= MaxReasonLength) {
              setReason(newReason);
            }
          }}
          placeholder="Enter Reason"
          className="form-control max-reason-height"
          maxLength={MaxReasonLength}
        />
        {load ? (
          <Spinner animation="border" />
        ) : (
          <Button
            className="btn btn-primary"
            onClick={handleSend}
            disabled={disabledDelete}
          >
            Delete
          </Button>
        )}
        <SuccessPopUp
          showPopup={successPopUp}
          message="Document was successfully deleted"
        />
      </Col>
    </>
  );
}
